import React, { useState, useEffect } from 'react';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { Save, CheckCircle, Image as ImageIcon, Loader2 } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion'; // Animasyon için eklendi
import './AboutManager.css';
import { db, storage } from '../firebase/firebase-config';

const AboutManager = () => {
  const [formData, setFormData] = useState({
    subTitle: '', 
    contentTitle: '', 
    content: '', 
    videoUrl: '', 
    img1: '', 
    img2: '',
    kaliteTitle: '', 
    kaliteContent: '', 
    kaliteImg: ''
  });
  
  const [loading, setLoading] = useState({ img1: false, img2: false, kaliteImg: false, submit: false });
  const [status, setStatus] = useState('');

  useEffect(() => {
    const fetchAboutData = async () => {
      const docRef = doc(db, "settings", "aboutContent");
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setFormData(docSnap.data());
      }
    };
    fetchAboutData();
  }, []);

  const handleImageUpload = async (e, fieldName) => {
    const file = e.target.files[0];
    if (!file) return;
    setLoading(prev => ({ ...prev, [fieldName]: true }));
    const storageRef = ref(storage, `about/${Date.now()}_${file.name}`);
    try {
      await uploadBytes(storageRef, file);
      const url = await getDownloadURL(storageRef);
      setFormData(prev => ({ ...prev, [fieldName]: url }));
    } catch (err) { 
      console.error("Yükleme hatası:", err); 
    }
    setLoading(prev => ({ ...prev, [fieldName]: false }));
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(prev => ({ ...prev, submit: true }));
    try {
      await setDoc(doc(db, "settings", "aboutContent"), formData);
      setStatus('success');
      // 3 saniye sonra bildirimi kaldır
      setTimeout(() => setStatus(''), 3000);
    } catch (err) { 
      console.error("Hata:", err); 
    }
    setLoading(prev => ({ ...prev, submit: false }));
  };

  const renderImagePreview = (fieldName, label) => (
    <div className="upload-item">
      <label>{label}</label>
      <div className="image-preview-box">
        {formData[fieldName] ? (
          <>
            <img src={formData[fieldName]} alt="Önizleme" />
            <div className="upload-overlay"><ImageIcon size={24} /><span>Değiştir</span></div>
          </>
        ) : (
          <div className="placeholder-content"><ImageIcon size={40} /><span>Görsel Seç</span></div>
        )}
        {loading[fieldName] && <div className="loading-overlay-abs"><Loader2 className="animate-spin" /></div>}
        <input type="file" onChange={(e) => handleImageUpload(e, fieldName)} id={`${fieldName}-input`} hidden />
        <label htmlFor={`${fieldName}-input`} className="full-click-label"></label>
      </div>
    </div>
  );

  return (
    <div className="panel-box">
      {/* Sağ Üst Başarı Bildirimi (Toast Popup) */}
      <AnimatePresence>
        {status === 'success' && (
          <motion.div 
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 100 }}
            className="status-toast"
          >
            <CheckCircle size={22} />
            <span>Değişiklikler başarıyla kaydedildi!</span>
          </motion.div>
        )}
      </AnimatePresence>

      <div className="admin-header-flex">
        <h3>Kurumsal İçerik Yönetimi</h3>
        <button onClick={handleSave} className="save-btn" disabled={loading.submit}>
          {loading.submit ? 'Kaydediliyor...' : <><Save size={18} /> Tümünü Kaydet</>}
        </button>
      </div>
      
      <div className="admin-form-grid">
        {/* SOL TARAF: HAKKIMIZDA FORM */}
        <section className="admin-section">
          <h4>Hakkımızda Bölümü</h4>
          <div className="form-group">
            <label>Hero Alt Başlık</label>
            <input type="text" value={formData.subTitle} onChange={(e)=>setFormData({...formData, subTitle: e.target.value})} />
          </div>
          <div className="form-group">
            <label>İçerik Başlığı</label>
            <input type="text" value={formData.contentTitle} onChange={(e)=>setFormData({...formData, contentTitle: e.target.value})} />
          </div>
          <div className="about-image-uploads">
            {renderImagePreview('img1', 'Kapak Fotoğrafı')}
            {renderImagePreview('img2', 'Detay Fotoğrafı')}
          </div>
          <div className="form-group">
            <label>Hakkımızda Metni</label>
            <textarea rows="5" value={formData.content} onChange={(e)=>setFormData({...formData, content: e.target.value})} />
          </div>
          <div className="form-group">
            <label>YouTube Video Linki</label>
            <input type="text" value={formData.videoUrl} onChange={(e)=>setFormData({...formData, videoUrl: e.target.value})} />
          </div>
        </section>

        {/* SAĞ TARAF: KALİTE POLİTİKASI FORM */}
        <section className="admin-section">
          <h4>Kalite Politikası Bölümü</h4>
          <div className="form-group">
            <label>Politika Başlığı</label>
            <input type="text" value={formData.kaliteTitle} onChange={(e)=>setFormData({...formData, kaliteTitle: e.target.value})} />
          </div>
          {renderImagePreview('kaliteImg', 'Politika Görseli')}
          <div className="form-group">
            <label>Politika Metni</label>
            <textarea rows="8" placeholder="Her maddeyi yeni bir satıra yazın..." value={formData.kaliteContent} onChange={(e)=>setFormData({...formData, kaliteContent: e.target.value})} />
          </div>
        </section>
      </div>
    </div>
  );
};

export default AboutManager;